/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "trash-open-016e4cda--sprite",
  "use": "trash-open-016e4cda--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"trash-open-016e4cda--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-155.776 -38.176)\"><path d=\"M168.524,53.851H179.1V63a2.128,2.128,0,0,1-2.115,2.139h-6.344A2.127,2.127,0,0,1,168.524,63h0\" fill=\"currentColor\" /><path d=\"M179.693,52.051a.975.975,0,0,1-1.234.583l-9.472-3.447a.972.972,0,0,1-.542-1.262.959.959,0,0,1,1.2-.561l3.411,1.241.185-.508a1.4,1.4,0,0,1,2.632.957h0l-.185.508,3.43,1.248a.962.962,0,0,1,.572,1.234Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
